import s from './style.css';

const sizes = [
	{
		name: 'medium',
		size: '456w'
	},
	{
		name: 'large',
		size: '608w'
	},
	{
		name: 'xlarge',
		size: '912w'
	},
	{
		name: 'xxlarge',
		size: '1216w'
	}
];

const Images = ({ id, isVisible, hasBeenSeen }) => (
	<div className={s.imageWrap}>
		<img
			alt={''}
			className={s.canvas}
			style={{
				opacity: isVisible ? 1 : 0
			}}
			src={hasBeenSeen ? `assets/large/section-${id}.png` : null}
			sizes="(min-height: 460px) AND (min-width: 460px) 456px,
        (min-height: 610px) AND (min-width: 860px) 608px"
			srcset={
				hasBeenSeen
					? sizes
						.map(
							({ name, size }) => `assets/${name}/section-${id}.png ${size}`
						)
						.join(', ')
					: null
			}
		/>
	</div>
);

export default Images;



// WEBPACK FOOTER //
// ./components/RomanceBreakdownViz/Images/index.js